export default "__VITE_ASSET__MaTLK2Qu__"